const memberDetail = resolve => require(["@/pages/member/memberManage/memberManageDetail.vue"], resolve);
const members = resolve => require(["@/pages/member/memberManage/index.vue"], resolve);
const memberDetails = resolve => require(["@/pages/member/memberManage/group/index.vue"], resolve);
const complaint = resolve =>
    require(["@/pages/member/complaint/index"], resolve);
const complaintDetail = resolve =>
    require([
        "@/pages/member/complaint/complaintModules/complaintDetail"
    ], resolve);
const memberLimit = resolve=>require(["@/pages/member/memberLimit"],resolve)

export default [
    /****************会员管理***************/
    {
        path: "/members",
        name: "会员管理",
        component: members,
        meta: {
            keepAlive: true
        }
    },
    {
        path: "/members/memberdetail",
        name: "基本信息",
        component: memberDetail,
    },
    {
        path: "/members/memberDetails/:type/:memberId",
        name: "发展详情",
        component: memberDetails,
        meta: {
            keepAlive: true
        }
    },
    /****************申诉管理***************/
    {
        path: "/complaint",
        component: complaint,
        meta: {
            keepAlive: true
        }
    },
    {
        path: "/complaintDetail",
        component: complaintDetail
    },
    /* **************注册登录限制管理*************** */
    {
        path:'/memberLimit',
        component:memberLimit
    }
];
